<template>
    <div>
        <dynamic-form :formConfig="formConfig" v-model="form" @submit="submit"></dynamic-form>
    </div>
</template>
<script>
import '@/components/dynamic-form';
export default {
    data() {
        return {
            form: {citys: [{id: '110101', name: '东城区'}]},
            formConfig: {
                inline: true,
                labelPosition: "right",
                labelWidth: "",
                size: "small",
                statusIcon: true,
                formItemList: [
                    {
                        label: '单选',
                        key: 'remoteCity',
                        type: 'databox',
                        props: {
                          label: 'name',
                          value: 'id'
                        },
                        url: '/dynamic/listData',
                        tableColumn: [
                            {
                                property: "number",
                                label: "编码",
                                query: {
                                     type: 'input'
                                }
                            },
                            {
                                property: "name",
                                label: "名称",
                                query: {
                                    type: 'input'
                                }
                            }
                        ],
                        extendParms: {queryFieldItem: 'id,number,name'},
                        multiple: false,
                        rules: {
                            required: true, message: '不能为空', trigger: 'change'
                        }
                    },
                    {
                        label: '单选(动态)',
                        key: 'city',
                        type: 'databox',
                        props: {
                          label: 'name',
                          value: 'id'
                        },
                        entityPath: "com.dst.slms.system.entity.SysOrgInfo",
                        extendParms: {queryFieldItem: 'id,number,name,parent.id'},
                        extendSearch: [
                            {
                                property: 'name',
                                query: {
                                    type: 'input'
                                }
                            }
                        ],
                        multiple: false,
                        rules: {
                            required: true, message: '不能为空', trigger: 'change'
                        }
                    },
                    {
                        label: '多选',
                        key: 'remoteCitys',
                        type: 'databox',
                        props: {
                          label: 'name',
                          value: 'id'
                        },
                        url: '/dynamic/listData',
                        tableColumn: [
                            {
                                property: "number",
                                label: "编码",
                                query: {
                                     type: 'input'
                                }
                            },
                            {
                                property: "name",
                                label: "名称",
                                query: {
                                    type: 'input'
                                }
                            }
                        ],
                        extendParms: {queryFieldItem: 'id,number,name'},
                        multiple: true,
                        clearable: true,
                        value: [],
                        rules: {
                            required: true, message: '不能为空', trigger: 'change'
                        }
                    },
                    {
                        label: '多选(动态)',
                        key: 'citys',
                        type: 'databox',
                        props: {
                          label: 'name',
                          value: 'id'
                        },
                        entityPath: "com.dst.slms.system.entity.SysAreaInfo",
                        extendParms: { queryFieldItem: 'id,number,name' },
                        extendSearch: [
                            {
                                property: 'name',
                                query: {
                                    type: 'group-input'
                                }
                            },
                            {
                                property: 'number',
                                query: {
                                    type: 'group-input'
                                }
                            }
                        ],
                        multiple: true,
                        clearable: true,
                        value: [],
                        rules: {
                            required: true, message: '不能为空', trigger: 'change'
                        }
                    }
                ]
            },
        }
    },
    methods: {
        submit(v) {
            console.log(v)
        }
    }
}
</script>
